import { NodeViewContent, NodeViewWrapper, type NodeViewProps } from '@tiptap/react';
import { ShieldCheck, Trash2 } from 'lucide-react';
import { Button } from '@design-system';

/** Counsel's words: marked apart from the reply, plain text only, sent in small print. */
export function LegalNoteView(props: NodeViewProps) {
  return (
    <NodeViewWrapper className="my-3 flex flex-col gap-2.5 rounded-xl border border-[#E9D5A6] bg-[#FFFAEB] p-3.5">
      <div
        contentEditable={false}
        className="flex flex-wrap items-center gap-2.5"
      >
        <span className="inline-flex items-center gap-1.5 rounded-full bg-[#FCEFC7] px-2.5 py-1 text-[13px] font-bold text-[#6B4100]">
          <ShieldCheck
            className="size-3.5"
            aria-hidden
          />
          Legal note
        </span>
        <span className="text-[13px] text-[#6B4100]">
          Sent word for word, in small print. Change it only with counsel’s approval.
        </span>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="ml-auto text-[#6B4100]"
          onClick={props.deleteNode}
        >
          <Trash2 aria-hidden /> Remove
        </Button>
      </div>
      <NodeViewContent className="min-h-[52px] rounded-[10px] border border-[#EADBB5] bg-white/70 px-3.5 py-3 text-sm leading-[1.8] text-zinc-700 focus-within:border-[#C9A24B]" />
    </NodeViewWrapper>
  );
}
